/* eslint-disable jira/filename-case */
/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */
export const GENERIC_PROJECT_HORIZONTAL_NAV = 'GENERIC_PROJECT_HORIZONTAL_NAV' as const;
